import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IRequisitionFields {
		id?: any;
		status?: any;
		datestamp?: any;
		changedById?: any;
		date?: any;
		uniqueId?: any;
		deliveryAddress?: any;
		contactPerson?: any;
		contactNumber?: any;
		latestRequisitionWorkflowId?: any;
		organisationId?: any;
		createdByUserId?: any;
		isStore?: any;
  warehouseId?: any;
  isPettyCash?: any;
  poComments?: any;
  isReservationOrder?: any;
}

export class RequisitionFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public changedById: IEntityModelField = { name: "changedById", displayName: "Changed By Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public date: IEntityModelField = { name: "date", displayName: "Date", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public uniqueId: IEntityModelField = { name: "uniqueId", displayName: "Unique Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public deliveryAddress: IEntityModelField = { name: "deliveryAddress", displayName: "Delivery Address", fieldType: FieldType.String, pattern: "NameGeneric" };
	public contactPerson: IEntityModelField = { name: "contactPerson", displayName: "Contact Person", fieldType: FieldType.String, pattern: "NameGeneric" };
	public contactNumber: IEntityModelField = { name: "contactNumber", displayName: "Contact Number", fieldType: FieldType.String, pattern: "NameGeneric" };
	public latestRequisitionWorkflowId: IEntityModelField = { name: "latestRequisitionWorkflowId", displayName: "Latest Requisition Workflow Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public organisationId: IEntityModelField = { name: "organisationId", displayName: "Organisation Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public createdByUserId: IEntityModelField = { name: "createdByUserId", displayName: "Created By User Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public isStore: IEntityModelField = { name: "isStore", displayName: "Is Store", fieldType: FieldType.Byte, pattern: "NameGeneric" };
  public warehouseId: IEntityModelField = { name: "warehouseId", displayName: "Warehouse Id", fieldType: FieldType.String, pattern: "NameGeneric" }; 
  public isPettyCash: IEntityModelField = { name: "isPettyCash", displayName: "Is Petty Cash", fieldType: FieldType.Byte, pattern: "NameGeneric" };
  public poComments: IEntityModelField = { name: "poComments", displayName: "PO Document Comments (Will be populated on the PO Document)", fieldType: FieldType.Byte, pattern: "NameGeneric" };
  public isReservationOrder: IEntityModelField = { name: "isReservationOrder", displayName: "Is Reservation Order?", fieldType: FieldType.Byte, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.date);
		this.push(this.uniqueId);
		this.push(this.deliveryAddress);
		this.push(this.contactPerson);
		this.push(this.contactNumber);
		this.push(this.latestRequisitionWorkflowId);
		this.push(this.organisationId);
		this.push(this.createdByUserId);
		this.push(this.isStore);
    this.push(this.isPettyCash);
    this.push(this.poComments);
    this.push(this.isReservationOrder);
	}
}

export class RequisitionDTO implements IEntityModel {
	protected requisitionName: string = "RequisitionModel";
	protected requisitionKeyField: string = "id";
	protected requisitionDisplayName: string = "Requisition|Requisitions";
	protected requisitionFields = new RequisitionFields();
	public get name(): string { return this.requisitionName };
	public get keyField(): string { return this.requisitionKeyField };
	public get displayName(): string { return this.requisitionDisplayName };
	public get fields(): RequisitionFields { return this.requisitionFields };

	constructor() {};
}
